module.exports = __webpack_public_path__ + "img/order.1e7faac6.png";